<template>
  <b-card
    no-body
    class="p-2"
  >
    <h3 class="mb-2">
      {{ $t('humanResources.employeeType.edit.editEmployeeType') }}
    </h3>
    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <b-form
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <b-row>
          <!-- employee type field -->
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Customs"
              rules="required"
            >
              <b-form-group
                :label="$t('humanResources.employeeType.columns.employeeType')"
                :state="errors.length > 0 ? false:null"
              >
                <b-form-input
                  v-model="employeeType.nombre"
                />
                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- Description Field -->
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Description"
              rules="required"
            >
              <b-form-group
                :label="$t('humanResources.employeeType.columns.description')"
                :state="errors.length > 0 ? false:null"
              >
                <b-form-input
                  v-model="employeeType.descripcion"
                />
                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          type="submit"
        >
          {{ $t('Lists.saveChanges') }}
        </b-button>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  // BFormTextarea,

  BFormInvalidFeedback,
  BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import humanResources from '@/services/humanresources.service'
import { ref } from '@vue/composition-api'
import router from '@/router'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormInvalidFeedback,
    BFormGroup,
    BButton,
    ValidationProvider,
    ValidationObserver,

  },
  setup() {
    /* SERVICES */
    const {
      updateEmployeeType,
      fetchEmployeeType,
    } = humanResources()

    // Data
    const employeeType = ref({})
    fetchEmployeeType(router.currentRoute.params, data => {
      employeeType.value = data
    })
    /* Events */
    const onSubmit = () => {
      updateEmployeeType(employeeType.value)
        .then(() => {
          router.push({ name: 'apps-human-resources-employee-type-list' })
        })
    }
    /* Validations */
    const employeeTypeData = ref(JSON.parse(JSON.stringify(employeeType.value)))
    const resetclienteData = () => {
      employeeTypeData.value = JSON.parse(JSON.stringify(employeeType))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetclienteData)
    return {
      // Data
      employeeType,
      /* Events */
      onSubmit,
      // Validations
      required,
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style>

</style>
